module.exports = __webpack_public_path__ + "static/media/MoveIt.932cc0d0.JPG";